import { EQuizMode } from '@constants';
import { InputNumber } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import {
  DescriptionWrapper,
  InfoWrapper,
  ItemWrapper,
  LoadingInfoWrapper,
  LoadingTitleWrapper,
  LoadingWrapper,
  TitleWrapper,
  Wrapper
} from './AiGenerationOption.styles';

import { SectionFilesSelector } from '@/components/Form';
import { LoadingCircleSpinner } from '@/components/Loaders';
import { useQuizForm } from '@/hooks';

const LOADING_SPINNER_SIZE = 40;

type Props = {
  isGeneratingQuestions: boolean;
};

export const AiGenerationOption: React.FC<Props> = ({ isGeneratingQuestions }) => {
  const { t } = useTranslation('ManagerQuizzesTranslations');
  const { config, setConfig } = useQuizForm();

  useEffect(() => {
    if (!config.questionCount)
      setConfig({
        ...config,
        questionCount: 20,
        answersCount: config.mode === EQuizMode.TRUE_FALSE ? 2 : 4
      });
  }, []);

  return (
    <Wrapper>
      <TitleWrapper>
        <div>{t('NUMBER_OF_QUESTIONS')}</div>
        <InputNumber
          value={config.questionCount}
          max={config.mode === EQuizMode.QUIZ ? 20 : 30}
          onChange={value => setConfig({ ...config, questionCount: value as number })}
        />
      </TitleWrapper>
      <TitleWrapper
        style={{ visibility: config.mode === EQuizMode.TRUE_FALSE ? 'hidden' : 'visible' }}>
        <div>{t('NUMBER_OF_ANSWERS')}</div>
        <InputNumber
          value={config.answersCount}
          max={5}
          min={2}
          onChange={value => setConfig({ ...config, answersCount: value as number })}
        />
      </TitleWrapper>
      <ItemWrapper>
        <InfoWrapper>
          <TitleWrapper>{t('SELECT_FILES')}</TitleWrapper>
          <DescriptionWrapper>{t('SELECT_FILES_DESCRIPTION')}</DescriptionWrapper>
        </InfoWrapper>
        <SectionFilesSelector
          value={config.selectedFiles}
          onChange={value => setConfig({ ...config, selectedFiles: value })}
          sectionId={config.section}
        />
      </ItemWrapper>
      {isGeneratingQuestions && (
        <LoadingWrapper>
          <LoadingCircleSpinner size={LOADING_SPINNER_SIZE} />
          <LoadingInfoWrapper>
            <LoadingTitleWrapper>{t('GENERATING_QUESTIONS')}</LoadingTitleWrapper>
            <div>{t('IT_CAN_TAKE_UP_TO_A_MINUTE')}</div>
          </LoadingInfoWrapper>
        </LoadingWrapper>
      )}
    </Wrapper>
  );
};
